module.exports = __webpack_public_path__ + "b11c21a62a7949487bc32b8e517924fb.png";